import Vue from 'vue';
import CookieConsent from '@/components/CookieConsent.vue';
export default Vue.extend({
    components: {
        CookieConsent,
    },
    props: {
        title: {
            type: String,
            default: 'Checkout',
        },
        backToShopping: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            scrolled: false,
        };
    },
    mounted() {
        this.scroll();
    },
    destroyed() {
        window.onscroll = null;
    },
    methods: {
        scroll() {
            window.onscroll = () => {
                const HEADER_HEIGHT = 145;
                if (document.documentElement.scrollTop < HEADER_HEIGHT) {
                    this.scrolled = false;
                }
                else {
                    this.scrolled = true;
                }
            };
        },
    },
});
